import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import Image from "../library/Image";
import User from "./User";
import Model from "./Model";
export class UserIdVerification extends Model {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "Id", {
      fieldName: 'id',
      content: null
    });
    _defineProperty(this, "User", {
      fieldName: 'user',
      model: User,
      content: null
    });
    _defineProperty(this, "FullName", {
      fieldName: 'full_name',
      content: null
    });
    _defineProperty(this, "IdFrontImage", {
      fieldName: 'id_front_image',
      model: Image,
      content: null
    });
    _defineProperty(this, "IdBackImage", {
      fieldName: 'id_back_image',
      model: Image,
      content: null
    });
    _defineProperty(this, "VerificationStatus", {
      fieldName: 'verification_status',
      content: null
    });
    _defineProperty(this, "Comments", {
      fieldName: 'comments',
      content: null
    });
    _defineProperty(this, "IsSubmitted", {
      fieldName: 'is_submitted',
      content: null
    });
  }
  isSubmitted() {
    var _this$IsSubmitted;
    return (_this$IsSubmitted = this.IsSubmitted) === null || _this$IsSubmitted === void 0 ? void 0 : _this$IsSubmitted.content;
  }
  getVerificationStatus() {
    var _this$VerificationSta;
    return (_this$VerificationSta = this.VerificationStatus) === null || _this$VerificationSta === void 0 ? void 0 : _this$VerificationSta.content;
  }
  getVerificationComments() {
    var _this$Comments;
    return (_this$Comments = this.Comments) === null || _this$Comments === void 0 ? void 0 : _this$Comments.content;
  }
  getFullName() {
    var _this$FullName;
    return (_this$FullName = this.FullName) === null || _this$FullName === void 0 ? void 0 : _this$FullName.content;
  }
  getIdFrontImage() {
    var _this$IdFrontImage;
    return (_this$IdFrontImage = this.IdFrontImage) === null || _this$IdFrontImage === void 0 ? void 0 : _this$IdFrontImage.content;
  }
  getIdFrontImageUrl() {
    let image_id_front = this.getIdFrontImage();
    return image_id_front instanceof Image ? image_id_front.getImageUrl() : null;
  }
  getIdBackImage() {
    var _this$IdBackImage;
    return (_this$IdBackImage = this.IdBackImage) === null || _this$IdBackImage === void 0 ? void 0 : _this$IdBackImage.content;
  }
  getIdBackImageUrl() {
    let image_id_back = this.getIdBackImage();
    return image_id_back instanceof Image ? image_id_back.getImageUrl() : null;
  }
}
_defineProperty(UserIdVerification, "VERIFICATION_PENDING_STATUS", 'pending');
_defineProperty(UserIdVerification, "VERIFICATION_REJECTED_STATUS", 'rejected');
_defineProperty(UserIdVerification, "VERIFICATION_VERIFIED_STATUS", 'verified');
export default UserIdVerification;